import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { SiMicrosoftteams, SiGooglechat, SiBattledotnet } from "react-icons/si";
import { FaHandshake } from "react-icons/fa";
import Booking from "../buttons/Booking";
import LearnMore from "../buttons/LearnMore";
import { educareSliderThree, educareSliderFour } from "../../assets";

const Banner = () => {
  return (
    <div className="bg-banner-background bg-no-repeat h-auto bg-cover w-full mb-4">
      <div className="w-full h-auto bg-primeColor bg-opacity-80">
        <div className="max-w-screen-2xl mx-auto px-4 flex flex-col py-4 md:py-10 xl:py-0 lg:flex-row items-center overflow-hidden">
          <div className="w-full xl:w-2/4 flex flex-col justify-start gap-10 text-white relative">
            <motion.div
              initial={{ x: -100, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{
                delay: 0.2,
                x: { type: "spring", stiffness: 60 },
                opacity: { duration: 1 },
                ease: "easeIn",
                duration: 1,
              }}
              className="flex flex-col gap-4"
            >
              <h1 className="text-3xl mb-4 text-white tracking-wide xl:leading-[40px] font-semibold font-bodyFont">
                Achieve Fluency in English with Educare English Learning
                Academy&apos;s Natural Language Learning Approach
              </h1>
              <h3 className="font-bodyFont text-base">
                Advance Your English Speaking, Writing, and Listening Skills
                with Educare English Learning Academy. From Fundamentals to
                Advanced Levels, Our Experts Help You Master Grammatical
                Structures and Vocabulary for Fluent Communication. Join Us
                Today for Comprehensive English Learning Solutions.
              </h3>
            </motion.div>
            <motion.div
              initial={{ x: -200, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{
                delay: 0.2,
                x: { type: "spring", stiffness: 60 },
                opacity: { duration: 1 },
                ease: "easeIn",
                duration: 1,
              }}
              className="flex flex-col lg:flex-row lg:items-center gap-4"
            >
              <Link to="/aboutus">
                <LearnMore />
              </Link>

              <Link to="/admission">
                <div>
                  <Booking />
                </div>
              </Link>
            </motion.div>
          </div>
          {/* ==================== Image section start here ======================= */}
          <div className="w-full xl:w-2/4 h-auto rounded-2xl pt-6 xl:pt-24 lg:px-8">
            <motion.div
              initial={{ x: 200, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{
                delay: 0.2,
                x: { type: "spring", stiffness: 60 },
                opacity: { duration: 1 },
                ease: "easeIn",
                duration: 1,
              }}
              className="w-full flex-col lgl:flex-row relative h-auto lgl:h-[600px] overflow-hidden"
            >
              <img
                className="object-cover w-full h-[300px] md:h-[400px] lgl:h-1/2 xl:w-[400px] xl:h-[430px] rounded-lg xl:rounded-tr-[120px] xl:rounded-bl-[120px] xl:border-t-8 xl:border-t-yellow-400 xl:top-0 xl:left-4 transition-hover duration-700 mb-4 xl:mb-0"
                src={educareSliderThree}
                alt="educareSliderOne"
              />
              <img
                className="object-cover w-full h-[300px] md:h-[400px] lgl:h-1/2 xl:w-[300px] xl:h-[300px] rounded-lg xl:right-0 xl:top-[35%] xl:rounded-tl-[100px] xl:rounded-br-[100px] xl:border-t-8 xl:border-t-yellow-400 transition-hover duration-700 xl:absolute"
                src={educareSliderFour}
                alt="educareSliderTwo"
              />
            </motion.div>
          </div>
          {/* ==================== Image section here ======================= */}
        </div>
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true }}
          transition={{
            delay: 0.2,
            x: { type: "spring", stiffness: 60 },
            opacity: { duration: 1 },
            ease: "easeIn",
            duration: 1,
          }}
          className="max-w-screen-2xl mx-auto text-white pb-16 flex flex-col lgl:flex-row items-center justify-around px-4 xl:px-0 gap-6 xl:gap-6 flex-wrap"
        >
          <div className="w-[330px] flex flex-row items-center gap-4 p-2 bg-transparent shadow-md shadow-gray-600">
            <span>
              <SiMicrosoftteams className="text-4xl text-darkPink" />
            </span>
            <h3 className="text-lg font-titleFont">
              A team of leading teaching experts
            </h3>
          </div>
          <div className="w-[330px] flex flex-row items-center gap-4 p-2 bg-transparent shadow-md shadow-gray-600">
            <span>
              <SiBattledotnet className="text-4xl text-darkPink" />
            </span>
            <h3 className="text-lg font-titleFont">
              A full range of educational guidelines
            </h3>
          </div>
          <div className="w-[330px] flex flex-row items-center gap-4 p-2 bg-transparent shadow-md shadow-gray-600">
            <span>
              <FaHandshake className="text-4xl text-darkPink" />
            </span>
            <h3 className="text-lg font-titleFont">
              Exclusive extensive online consulting guides
            </h3>
          </div>
          <div className="w-[330px] flex flex-row items-center gap-4 p-2 bg-transparent shadow-md shadow-gray-600">
            <span>
              <SiGooglechat className="text-4xl text-darkPink" />
            </span>
            <h3 className="text-lg font-titleFont">
              100% free first Educational consultation for all new students
            </h3>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Banner;
